import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { DefaultInfo } from "components/NothingRight";
import ReceiverCreation from "./ReceiverCreation";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      flexDirection: "row",
      height: "100vh",
      width: "100%",
      paddingTop: "60px",
      "@media(max-width: 1256px)": {
        flexDirection: "column-reverse",
      },
      marginBottom: 0,
    },
    left: {
      width: "70%",
      margin: theme.spacing(2),
      "@media(max-width: 1256px)": {
        flex: "1 100% 100%",
        width: "100%",
        marginTop: 0,
      },
    },
    right: {
      width: "30%",
      margin: theme.spacing(0.2),
      padding: theme.spacing(2),
      background: "#fff",
      flex: "1 18%",
      "@media(max-width: 1256px)": {
        display: "none",
      },
    },
  })
);

export const ReceiverCreationScreen = () => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <ReceiverCreation />
      </div>
      <div className={styles.right}>
        <DefaultInfo />
      </div>
    </div>
  );
};

export default ReceiverCreationScreen;
